import * as TabsPrimitive from '@radix-ui/react-tabs'
import cx from 'classnames'
import { motion } from 'framer-motion'
import React, { ComponentProps } from 'react'
import { TabsContext, useTabsContext } from '../contexts'

type TabsProps<T extends string> = {
  onTabChange?: (newTab: T) => void
  selectedTabState?: [T, React.Dispatch<React.SetStateAction<T>>]
} & ComponentProps<typeof TabsPrimitive.Root>

export const Tabs = <T extends string>({ selectedTabState, onTabChange, defaultValue, ...props }: TabsProps<T>) => {
  const [selectedTab, setSelectedTab] = selectedTabState || React.useState(defaultValue)

  const onValueChange = (newTab: string) => {
    setSelectedTab(newTab as T)
    onTabChange?.(newTab as T)
  }

  return (
    <TabsContext.Provider value={{ selectedTab }}>
      <TabsPrimitive.Root
        {...props}
        defaultValue={defaultValue}
        value={selectedTab}
        onValueChange={onValueChange}
        className={cx('flex flex-col')}
      />
    </TabsContext.Provider>
  )
}

Tabs.List = (props: ComponentProps<typeof TabsPrimitive.List>) => {
  return <TabsPrimitive.List {...props} className={cx('flex flex-row', props.className)} />
}

Tabs.Trigger = (props: ComponentProps<typeof TabsPrimitive.Trigger>) => {
  const { selectedTab } = useTabsContext()
  return (
    <div className="flex flex-col items-center pb-4">
      <TabsPrimitive.Trigger {...props} className={cx('mx-4 mb-0.5 mt-4 text-sm text-gray-11 hover:text-gray-12')} />
      {selectedTab === props.value && <motion.div layoutId="tab" className={cx('h-0.5 w-10/12 bg-accent-9')} />}
    </div>
  )
}
Tabs.Content = TabsPrimitive.Content
